<template>
    <q-page class="q-pa-md">
        <q-dialog class="rounded-borders" v-model="dialogPagosAnteriores" persistent>
            <q-card v-if="selectCuenta != null" style="width: 600px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Comprobante de Pago</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-card class="shadow-0" v-if="selectCuenta != null">
                        <q-card-section class="row items-center q-col-gutter-md q-pb-none">
                            <div class="col-12 col-md-12">
                                <q-file v-model="archivoSeleccionado" dense outlined label="Subir Comprobante de Pago"
                                    class="full-width">
                                </q-file>
                            </div>
                            <div class="col-12 col-md-12">
                                <q-input class="q-pb-none" dense outlined v-model="fechaPago"
                                    label="Fecha en la que se realizo el Pago" mask="date" bottom-slots
                                    placeholder="yyyy/MM/dd">
                                    <template v-slot:after>
                                        <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                            <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy"
                                                transition-show="scale" transition-hide="scale">
                                                <q-date class="q-ma-none q-pa-none" v-model="fechaPago">
                                                    <div class="row items-center justify-end q-ma-none q-pa-none">
                                                        <q-btn v-close-popup label="Ok" color="primary"
                                                            class="q-ma-none q-pa-none" flat />
                                                    </div>
                                                </q-date>
                                            </q-popup-proxy>
                                        </q-icon>
                                    </template>
                                </q-input>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-card-section>
                <q-card-section>
                    <div class="row">
                        <q-btn flat color="red" label="CERRAR" class="q-ml-sm" v-close-popup />
                        <q-space />
                        <q-btn flat class="q-ml-sm" color="primary" label="Guardar Comprobante"
                            @click="ConfirmarPagoAnterior()" />
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>

        <!-- <q-dialog class="rounded-borders" v-model="dialogPagosAnteriores" persistent>
            <q-card v-if="selectCuenta != null" style="width: 350px;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Pago</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section class="row q-my-md">
                    <q-input class=" q-ma-none q-pa-none full-width" dense outlined v-model="fechaPago"
                        label="Fecha del Pago" mask="date" bottom-slots placeholder="yyyy/MM/dd">
                        <template v-slot:after>
                            <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                    transition-hide="scale">
                                    <q-date class="q-ma-none q-pa-none" v-model="fechaPago">
                                        <div class="row items-center justify-end q-ma-none q-pa-none">
                                            <q-btn v-close-popup label="Ok" color="primary" class="q-ma-none q-pa-none"
                                                flat />
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                </q-card-section>
                <q-card-actions class="row">
                    <q-btn flat class="q-ml-sm full-width" color="primary" label="Validar Pago"
                        @click="ConfirmarPagoAnterior()" />
                </q-card-actions>
            </q-card>
        </q-dialog> -->


        <q-dialog class="rounded-borders" v-model="dialogNuevaCuenta" persistent>
            <q-card style="width: 800px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Nueva Cuenta por Cobrar</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section class="row items-center q-pb-none q-col-gutter-md ">
                    <div class="col-12">
                        <q-select outlined v-model="selectClienteCuenta" :options="clientes" label="Nombre del Cliente"
                            option-label="rfc" dense required emit-value map-options
                            @input="GetVehiculosPorClienteAsync">
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-account" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label v-html="scope.opt.rfc + ' ' + scope.opt.razon_social" />
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>
                    <div class="col-12">
                        <q-select outlined v-model="selectAuto" :options="autosCliente" label="Vehículo"
                            option-label="texto" option-value="id" dense emit-value map-options>
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-car" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label>{{ scope.opt.marca }} {{ scope.opt.modelo }} ({{ scope.opt.anio
                                        }})</q-item-label>
                                        <q-item-label caption>Placa: {{ scope.opt.placa }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>
                    <div class="col-12 col-md-12">
                        <q-input dense v-model="concepto" outlined label="Concepto" required />
                    </div>
                    <div class="col-12 col-md-6">
                        <q-input prefix="$" dense v-model="monto" outlined label="Monto a Pagar" required mask="#.##"
                            fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>
                    <div class="col-12 col-md-6">
                        <q-input class="q-pb-none" dense outlined v-model="fechamaximapago"
                            label="Fecha de Maxima de Pago" mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fechamaximapago">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>
                    <!-- <div class="col-12 col-md-6">
                                <q-input class="q-pb-none" dense outlined v-model="fechamafacturacion"
                                    label="Fecha de Maxima de Facturación" mask="date" bottom-slots
                                    placeholder="yyyy/MM/dd">
                                    <template v-slot:after>
                                        <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                            <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy"
                                                transition-show="scale" transition-hide="scale">
                                                <q-date class="q-ma-none q-pa-none" v-model="fechamafacturacion">
                                                    <div class="row items-center justify-end q-ma-none q-pa-none">
                                                        <q-btn v-close-popup label="Ok" color="primary"
                                                            class="q-ma-none q-pa-none" flat />
                                                    </div>
                                                </q-date>
                                            </q-popup-proxy>
                                        </q-icon>
                                    </template>
                                </q-input> -->
                    <!-- </div> -->
                </q-card-section>

                <q-card-actions class="row justify-between">
                    <q-btn flat color="red" label="Cerrar" v-close-popup />
                    <q-btn @click="PostCuentaCobrar()" flat color="primary" label="Crear Cuenta" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogConfirmacion" persistent>
            <q-card v-if="selectCuenta != null">
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-information-variant" color="info" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h6 q-ml-lg">¿Confirmas que los datos del pago del día
                                <strong>{{ fechaPago }}</strong> son correctos.?</span>
                        </div>
                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Al confirmar que los datos del pago son correctos, se procedera a la
                            elaboración del contrato.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" v-close-popup />
                    <q-btn label="Aceptar" color="primary" @click="UpdateCxc()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogConfirmacionPagoAnterior" persistent>
            <q-card v-if="selectCuenta != null">
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-information-variant" color="info" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h6 q-ml-lg">¿Confirmas que los datos del pago del día
                                <strong>{{ fechaPago }}</strong> son correctos.?</span>
                        </div>
                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Al confirmar que los datos del pago son correctos, la cuenta por cobrar
                            pasara al estaus
                            pagado.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" v-close-popup />
                    <q-btn label="Aceptar" color="primary" @click="UpdateCxcCPasados()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogDetalles" persistent>
            <q-card v-if="selectCuenta != null" style="width: 1100px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Detalles del Comprobante de Pago</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section v-if="isPDF" style="max-height: 70vh" class="scroll">
                    <div class="text-center">
                        <q-btn icon="download" flat label="Descargar Comprobante" color="primary"
                            @click="descargarPDF" />
                    </div>
                    <VisualizadorPDF></VisualizadorPDF>
                </q-card-section>
                <q-card-section v-else>
                    <div class="text-center">
                        <q-btn icon="download" flat label="Descargar Comprobante" color="primary"
                            @click="descargarPDF" />
                    </div>
                    <q-img :src="this.$store.state.auth.storeBase64Cotizacion" style="max-width: 100%;" contain />
                </q-card-section>
                <q-card-actions v-if="selectCuenta.estado == 'V'" class="row">
                    <q-btn flat color="red" label="CERRAR" class="q-ml-sm" v-close-popup />
                    <q-space />
                    <q-input class="q-ma-none q-pa-none" dense outlined v-model="fechaPago" label="Fecha del Pago"
                        mask="date" bottom-slots placeholder="yyyy/MM/dd">
                        <template v-slot:after>
                            <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                    transition-hide="scale">
                                    <q-date class="q-ma-none q-pa-none" v-model="fechaPago">
                                        <div class="row items-center justify-end q-ma-none q-pa-none">
                                            <q-btn v-close-popup label="Ok" color="primary" class="q-ma-none q-pa-none"
                                                flat />
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                    <q-btn flat class="q-ml-sm" color="primary" label="Validar Comprobante" @click="ConfirmarPago()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md " style="height: 100%; overflow-y: auto;">
            <div class="col-12">
                <q-table dense title="Cuentas Por Cobrar" class="shadow-1 " :data="dataList" :loading="loading"
                    :columns="columns" color="primary" row-key="_id" :pagination="initialPagination"
                    :selected.sync="selected" selection="single">

                    <template v-slot:top-right>
                        <q-input class="q-ma-none q-pa-none q-mr-sm" dense outlined v-model="fechaI"
                            label="Fecha Inicial" mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:append>
                                <q-icon name="event" class="cursor-pointer q-ma-none q-pa-none">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fechaI">
                                            <div class="q-ma-none q-pa-none row items-center justify-end">
                                                <q-btn class="q-ma-none q-pa-none" v-close-popup label="Ok"
                                                    color="primary" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                        <q-input class="q-ma-none q-pa-none q-mr-sm" dense outlined v-model="fechaF" label="Fecha Final"
                            mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:append>
                                <q-icon name="event" class="cursor-pointer q-ma-none q-pa-none">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fechaF">
                                            <div class="q-ma-none q-pa-none row items-center justify-end">
                                                <q-btn class="q-ma-none q-pa-none" v-close-popup label="Ok"
                                                    color="primary" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                        <q-select outlined v-model="selectCliente" style="width: 200px;" :options="clientes"
                            label="Cliente" option-label="rfc" option-value="_id_cliente" dense required emit-value
                            map-options class="q-mr-sm" @input="GetVehiculosPorClienteConsultaAsync">
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-account" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label v-html="scope.opt.rfc + ' ' + scope.opt.razon_social" />
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                        <q-select outlined v-model="selectAutoConsulta" style="width: 200px;"
                            :options="autosClienteConsulta" class="q-mr-sm" label="Vehículo" option-label="texto"
                            option-value="id" dense emit-value map-options>
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-car" color="priamry" />
                                    </q-item-section>
                                    <q-item-section v-if="scope.opt.id == 'Todos'">
                                        <q-item-label>Todos</q-item-label>
                                        <q-item-label caption>Consulta todos las cuentas</q-item-label>
                                    </q-item-section>
                                    <q-item-section v-else>
                                        <q-item-label>{{ scope.opt.marca }} {{ scope.opt.modelo }} ({{ scope.opt.anio
                                            }})</q-item-label>
                                        <q-item-label caption>Placa: {{ scope.opt.placa }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                        <q-select outlined v-model="estadoCuenta" :options="itemsCuentasEstados" label="Estado"
                            class="q-my-md" option-label="label" option-value="value" dense required emit-value
                            map-options />
                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar" @click="GetCxC()" no-caps
                            class="q-ml-sm q-my-md" />
                        <q-btn outline color="primary" icon="mdi-plus" label="Nueva cuenta" no-caps
                            class="q-ml-sm q-my-md" @click="nuevaCuenta()" />
                        <q-btn outline color="primary" icon="mdi-check" label="Conciliar" no-caps
                            class="q-ml-sm q-my-md" @click="abrirValidar" />
                    </template>

                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <!-- Columna de selección -->
                            <q-td auto-width>
                                <q-checkbox v-if="props.row.estado == 'XC'" v-model="props.selected" />
                            </q-td>
                            <q-td key="nombre" :props="props" @click="verItem(props.row)">{{ props.row.nombre }}</q-td>
                            <q-td key="concepto" :props="props" @click="verItem(props.row)">{{ props.row.concepto
                            }}</q-td>
                            <q-td key="monto" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.monto) }}</q-td>
                            <q-td key="tipo" :props="props" @click="verItem(props.row)">{{ props.row.tipo ?
                                props.row.tipo.toUpperCase() : ''
                                }}</q-td>
                            <q-td key="fechacreacion" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechacreacion) }}</q-td>
                            <q-td key="fechamaximapago" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechamaximapago) }}</q-td>
                            <q-td key="estado" :props="props">
                                <q-badge v-if="props.row.estado == 'XC'" color="orange" label="Cuenta por Cobrar" />
                                <q-badge v-if="props.row.estado == 'V'" color="purple" label="Pendiente de Validar" />
                                <q-badge v-if="props.row.estado == 'P'" color="green" label="Pagado" />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import VisualizadorPDF from "../../PDF/VistasPreviasPDF.vue";
import moment from 'moment';
export default {
    components: {
        VisualizadorPDF
    },
    data() {
        return {
            loading: false,
            dataList: [],
            columns: [
                // { name: 'selection', label: '', field: 'selection', sortable: false },
                { name: 'nombre', label: 'Cliente', field: 'nombre', align: 'center', sortable: true },
                { name: 'concepto', label: 'Concepto', field: 'concepto', align: 'center', sortable: true },
                { name: 'monto', label: 'Monto', field: 'monto', align: 'right', sortable: true },
                { name: 'tipo', label: 'Tipo', field: 'tipo', align: 'center', sortable: true },
                { name: 'fechacreacion', label: 'Fecha', field: 'fechacreacion', align: 'center', sortable: true },
                { name: 'fechamaximapago', label: 'Fecha Maxima De Pago', field: 'fechamaximapago', align: 'center', sortable: true },
                { name: 'estado', label: 'Estatus', field: 'estado', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            itemsCuentasEstados: [
                { value: 'XC', label: 'Cuentas por Cobrar' },
                { value: 'V', label: 'Pendiente de Validar' },
                { value: 'P', label: 'Pagado' }
            ],
            estadoCuenta: 'XC',
            dialogDetalles: false,
            selectCuenta: null,
            selectEvidencia: null,
            isPDF: true,

            dialogConfirmacion: false,
            fechaPago: '',

            fechaI: new Date(),
            fechaF: new Date(),
            selectCliente: '',
            clientes: [],
            dialogNuevaCuenta: false,

            selectClienteCuenta: null,
            concepto: '',
            monto: 0,
            fechamaximapago: '',
            fechamafacturacion: '',
            selected: [],
            dialogPagosAnteriores: false,
            dialogConfirmacionPagoAnterior: false,

            archivoSeleccionado: null,
            selectAuto: null,
            autosCliente: [],

            autosClienteConsulta: [{ id: 'Todos', texto: 'Todos' }],
            selectAutoConsulta: null,
        }
    },
    async mounted() {
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.usuario;
        },
    },
    created() {
        this.GetClientes();
    },
    methods: {
        abrirValidar(item) {
            if (this.selected.length == 0) {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Debera seleccionar alguna cuenta.', messageColor: 'white' })
                return
            }

            this.selectCuenta = this.selected[0]

            this.dialogPagosAnteriores = true
        },
        async verItem(item) {
            this.selectCuenta = item
            if (item.estado == 'XC') {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'La cuenta por Cobrar esta en espera de algun comprobante de pago. Consulte mas tarde...', messageColor: 'white' })
                this.timer = setTimeout(() => {
                    this.$q.loading.hide()
                    this.timer = void 0
                }, 3000)
                return
            }
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando detalles. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.get('CXC/GetEvidenciaXId/' + this.selectCuenta._id)
                console.log(respuesa)
                this.$q.loading.hide()
                this.selectEvidencia = respuesa.data.evidencia
                this.$store.state.auth.storeBase64Cotizacion = this.selectEvidencia.b64com + ',' + this.selectEvidencia.ruta
                if (this.selectEvidencia.b64com == 'data:application/pdf;base64') {
                    this.isPDF = true
                } else {
                    this.isPDF = false
                }
                this, this.dialogDetalles = true
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },

        async PostCuentaCobrar() {
            if (this.selectClienteCuenta == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el cliente al que se le haran los cargos.` });
                return
            }
            if (this.concepto == "") {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el concepto de pago.` });
                return
            }
            if (this.monto == 0) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `El monto a pagar debe ser mayo a $0.00.` });
                return
            }
            if (this.fechamaximapago == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique una fecha maxima para realizar el pago.` });
                return
            }
            // if (this.fechamafacturacion == '') {
            //     this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique una fecha maxima para realizar la factura.` });
            //     return
            // }
            try {
                let cxc = {
                    id_documento: null,
                    id_cliente: this.selectClienteCuenta._id_cliente,
                    nombre: this.selectClienteCuenta.rfc + " " + this.selectClienteCuenta.razon_social,
                    concepto: this.concepto,
                    monto: this.monto,
                    tipo: 'Cuenta por Cobrar',
                    procedencia: 'CXC',
                    fechamaximapago: this.fechamaximapago,
                    fechamafacturacion: null,
                    id_vehiculo: this.selectAuto,
                }

                console.log(cxc)
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Generando cuenta por cobrar. Espere...', messageColor: 'white' })

                const resp = await axios.post(`CXC/PostCxC/`, cxc);
                console.log(resp)

                if (respuesa.data.edopet == '1') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se creo y se envio la cuenta por cobrar correctamente.` });
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `La cuenta por cobrar se ha facturado correctamente.` });
                }
                if (respuesa.data.edopet == '0') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se creo y se envio la cuenta por cobrar correctamente.` });
                    this.$q.notify({ type: 'negative', position: 'top-right', message: respuesa.edopet.mensaje });
                }
                this.dialogNuevaCuenta = false
                this.$q.loading.hide()

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al regitrar la cuenta. Intentelo de nuevo...` });
                console.log(error)
            }
        },

        formatFecha(fecha) {
            if (!fecha) return ''
            let d = new Date(fecha)
            let anio = d.getFullYear()
            let mes = String(d.getMonth() + 1).padStart(2, '0')
            let dia = String(d.getDate()).padStart(2, '0')
            return `${anio}-${mes}-${dia}`
        },

        async GetCxC() {
            this.selected = []
            this.loading = true
            try {
                let respuesa = await axios.get('CXC/GetCxC/' + this.estadoCuenta + '/' + this.selectCliente + "/" + this.formatFecha(this.fechaI) + "/" + this.formatFecha(this.fechaF) + "/" + this.selectAutoConsulta)
                console.log(respuesa)
                this.dataList = respuesa.data.lista
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async UpdateCxcCPasados() {
            const archivo = this.archivoSeleccionado;

            if (!archivo) {
                this.$q.notify({
                    color: 'negative',
                    message: 'Debes seleccionar un archivo primero.',
                    position: 'top-right'
                });
                return;
            }

            const base64 = await this.convertirABase64(archivo);
            let nombre_archivo = archivo.name;
            let archivo64base = base64;

            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Validando comprobante de Pago. Espere...', messageColor: 'white' })

            let objeto = {
                idcxc: this.selectCuenta._id,
                estatus: 'P',
                imagen: archivo64base,
                nombre: nombre_archivo,
                fecha: this.fechaPago,
            }
            console.log(objeto)
            try {
                let respuesa = await axios.put('CXC/UpdateCxcCPasados/', objeto)
                console.log(respuesa)
                this.dialogConfirmacion = false
                this.dialogDetalles = false
                this.$q.loading.hide()
                this.$q.notify({ type: 'positive', position: 'top-right', message: `Se valido correctamente el comprbante de pago.` });
                this.GetCxC()
                this.selected = []
                this.dialogPagosAnteriores = false
                this.dialogConfirmacionPagoAnterior = false
            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al validar el comprobante, intentelo mas tarde.` });
                console.log(error)
            }
        },

        async UpdateCxc() {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Validando comprobante de Pago. Espere...', messageColor: 'white' })
            let objeto = {
                idcxc: this.selectCuenta._id,
                estatus: 'P',
                fecha: this.fechaPago,
            }
            console.log(objeto)
            try {
                let respuesa = await axios.put('CXC/UpdateCxc/', objeto)
                console.log(respuesa)
                this.dialogConfirmacion = false
                this.dialogDetalles = false
                this.$q.loading.hide()

                if (respuesa.data.edopet == '2') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se actualizo la cuenta por cobrar correctamente.` });
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `La cuenta por cobrar se ha facturado el complemento de pago correctamente.` });
                }
                if (respuesa.data.edopet == '0') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se actualizo la cuenta por cobrar correctamente.` });
                    this.$q.notify({ type: 'negative', position: 'top-right', message: respuesa.data.mensaje });
                }
                if (respuesa.data.edopet == '-1') {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al validar el comprobante, intentelo mas tarde.` });
                }

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al validar el comprobante, intentelo mas tarde.` });
                console.log(error)
            }
        },

        ConfirmarPago() {
            if (this.fechaPago == "") {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Confirme la fecha en la que se realizo el pago.` });
                return
            }
            this.dialogConfirmacion = true
        },

        ConfirmarPagoAnterior() {
            if (this.fechaPago == "") {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Confirme la fecha en la que se realizo el pago.` });
                return
            }
            this.dialogConfirmacionPagoAnterior = true
        },

        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;
        },
        descargarPDF() {
            const fileName = this.selectEvidencia.nombre;
            const link = document.createElement("a");
            link.href = this.$store.state.auth.storeBase64Cotizacion;
            link.download = fileName;
            link.click();
        },
        async GetClientes() {
            try {
                let respuesa = await axios.get('Configuracion/GetUsuariosDatosFiscales/')
                console.log(respuesa)
                this.clientes = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        nuevaCuenta() {
            this.dialogNuevaCuenta = true
            this.selectClienteCuenta = null
            this.concepto = ''
            this.monto = 0
            this.fechamaximapago = ''
            this.fechamafacturacion = ''
            this.selectAuto = null
        },
        convertirABase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        async GetVehiculosPorClienteAsync() {
            if (!this.selectClienteCuenta) return;

            try {
                const res = await axios.get(`Autos/GetVehiculosPorClienteAsync/${this.selectClienteCuenta._id_cliente}`);
                // Puedes agregar campo "texto" al vuelo si quieres usarlo en option-label (opcional)
                console.log(res)
                this.autosCliente = res.data.map(auto => ({
                    ...auto,
                    texto: `${auto.marca} ${auto.modelo} (${auto.anio}) - ${auto.placa}`
                }));
            } catch (err) {
                console.error('Error al obtener autos:', err);
                this.autosCliente = [];
            }
        },
        async GetVehiculosPorClienteConsultaAsync() {
            if (!this.selectCliente) return;

            try {
                const res = await axios.get(`Autos/GetVehiculosPorClienteAsync/${this.selectCliente}`);
                // Puedes agregar campo "texto" al vuelo si quieres usarlo en option-label (opcional)
                console.log(res)
                this.autosClienteConsulta = res.data.map(auto => ({
                    ...auto,
                    texto: `${auto.marca} ${auto.modelo} (${auto.anio}) - ${auto.placa}`
                }));

                this.autosClienteConsulta.unshift({ id: 'Todos', texto: "Todos" });

            } catch (err) {
                console.error('Error al obtener autos:', err);
                this.autosCliente = [];
            }
        },
    }
}
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>